import React from 'react'
import formatNumber from '@arsenal/arsenal/modules/formatNumber'
import { sendTeaCommEvent } from 'lib/tea-analyze'

interface IProps {
  className?: string
  list: {
    id: string
    title: string
    link: string
    viewCount: number
  }[]
  teaParams: { [key: string]: string }
  [key: string]: any
}

const List: React.FC<IProps> = ({ className, list, teaParams, ...props }) => {
  return (
    <div
      className={`common-top-text-list ${className ? className : ''}`}
      {...props}
    >
      {list?.map((item, index) => {
        return (
          <a
            className="item-wrap"
            href={item?.link}
            key={index}
            target="_blank"
            title={item?.title}
            onClick={() => {
              if (!teaParams) {
                return
              }
              sendTeaCommEvent(
                'clk_event',
                Object.assign(teaParams, {
                  group_id: item.id,
                  rank: `${index}`,
                })
              )
            }}
          >
            <div className={`rank-top top-${index + 1}`} />
            <div className="item">
              <div className="title line-1 g-active-link-text">
                {item?.title}
              </div>
              <div className="stats">{formatNumber(item.viewCount)}次观看</div>
            </div>
          </a>
        )
      })}
      <style jsx>
        {`
          .common-top-text-list {
            margin-top: -8px;
          }
          .item-wrap {
            display: flex;
            width: 100%;
            align-items: center;
            padding: 8px 0 9px;
            cursor: pointer;
          }
          .item-wrap:hover {
            border-radius: 2px;
            background-color: #ffffff;
          }
          .item-wrap:first-child {
            margin-top: 0;
          }
          .rank-top {
            width: 31px;
            height: 35px;
            position: relative;
            margin-right: 8px;
            background-image: url(${require('static/rank.svg')});
            background-size: 66px 350px;
          }
          .item {
            flex: 1;
            overflow: hidden;
          }
          .title {
            height: 24px;
            margin: 0 0 4px;
            font-family: PingFangSC;
            font-size: 16px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.5;
            letter-spacing: normal;
            color: #1f2129;
          }
          .stats {
            font-family: PingFangSC;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            color: #606370;
          }
          .top-1 {
            background-position: 0 0;
          }
          .top-2 {
            background-position: 0 -35px;
          }
          .top-3 {
            background-position: 0 -70px;
          }
          .top-4 {
            background-position: 0 -105px;
          }
          .top-5 {
            background-position: 0 -140px;
          }
          .top-6 {
            background-position: 0 -175px;
          }
          .top-7 {
            background-position: 0 -210px;
          }
          .top-8 {
            background-position: 0 -245px;
          }
          .top-9 {
            background-position: 0 -280px;
          }
          .top-10 {
            background-position: 0 -315px;
          }
        `}
      </style>
    </div>
  )
}

export default List
